import React, { useContext, useEffect, useState } from 'react';
import { Form, Input, Button, Checkbox, message, Divider } from 'antd';
import { GoogleOutlined, LoginOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { buildApiUrl } from '../config/api';
import '../styles/index.css';

// OIDC 소셜 로그인 시작: 백엔드가 IdP authorize URL로 리다이렉트한다.
const startOAuth = (provider) => {
  window.location.href = buildApiUrl(`/api/auth/oauth/${provider}/start`);
};

const Login = () => {
  const navigate = useNavigate();
  const { login, auth } = useContext(AuthContext);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/main');
    }
  }, [auth, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(buildApiUrl('/api/login'), {
        User_ID: values.User_ID,
        User_PW: values.User_PW,
      });

      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('User_ID', values.User_ID);
        localStorage.setItem('User_Class_IDX', response.data.user.User_Class_IDX.toString());

        if (values.remember) {
          localStorage.setItem('remember', true);
        } else {
          localStorage.removeItem('remember');
        }

        login({
          User_ID: values.User_ID,
          token: response.data.token,
          User_Class_IDX: response.data.user.User_Class_IDX,
          menuPermissions: response.data.menu_permissions || [],
        });
        navigate('/main');
      } else {
        message.error('로그인에 실패했습니다: ' + (response.data.message || '알 수 없는 오류가 발생했습니다.'));
      }
    } catch (error) {
      if (error.response?.status === 401) {
        message.error('아이디 또는 비밀번호가 올바르지 않습니다.');
      } else {
        message.error('로그인 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message));
      }
      console.error('Login error:', error);
    } finally {
      setLoading(false);
    }
  };

  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  };

  const handleSignup = () => {
    navigate('/signup');
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          style={{ width: 300 }}
        >
          <Form.Item
            label="아이디"
            name="User_ID"
            rules={[{ required: true, message: '아이디를 입력하세요.' }]}
            colon={false}
          >
            <Input autoComplete="username" />
          </Form.Item>

          <Form.Item
            label="비밀번호"
            name="User_PW"
            rules={[{ required: true, message: '비밀번호를 입력하세요.' }]}
            colon={false}
          >
            <Input.Password autoComplete="current-password" />
          </Form.Item>

          <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 8, span: 16 }}>
            <Checkbox>로그인 정보 저장</Checkbox>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <div style={{ display: 'flex', gap: '10px' }}>
              <Button type="primary" htmlType="submit" loading={loading}>
                로그인
              </Button>
              <Button type="default" onClick={handleSignup}>
                회원가입
              </Button>
            </div>
          </Form.Item>
        </Form>

        <Divider plain style={{ fontSize: 12 }}>또는</Divider>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: 300, margin: '0 auto' }}>
          <Button icon={<GoogleOutlined />} block onClick={() => startOAuth('google')}>
            Google로 로그인
          </Button>
          <Button icon={<LoginOutlined />} block onClick={() => startOAuth('authentik')}>
            Authentik으로 로그인
          </Button>
        </div>
      </div>
    </div>
  );
};
export default Login;
